import { CLINICAL_BASE_PATH } from '../constants';

export const BASE_VARIANT_CLASSIFICATION_PATH = `${CLINICAL_BASE_PATH}/variant_classifications`;

export const VARIANT_CLASSIFICATION_LIST_PATH = `${BASE_VARIANT_CLASSIFICATION_PATH}`;
export const VARIANT_CLASSIFICATION_DETAIL_PATH = `${BASE_VARIANT_CLASSIFICATION_PATH}/:id`;
